module.exports = __webpack_public_path__ + "img/ideal.f43da5b8.svg";